// extracted by mini-css-extract-plugin
module.exports = {"cont":"TermsView_cont__3b7_A","flex":"TermsView_flex__WmXwT","space":"TermsView_space__2G00v"};